/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ac-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:before{font-family:FontAwesome;content:\"\\f0a9\";display:inline-block;margin-right:.5em;vertical-align:top}.ac-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .d-inline-block[_ngcontent-%COMP%]{width:90%}@media screen and (min-width:992px){.ac-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .d-inline-block[_ngcontent-%COMP%]{width:85%}}"];
export { styles as styles };
